import React from 'react';

export const CancellationIcon = ({ stroke = '#1C452B', width, height, className }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 59 59" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <path d="M29.4328 57.0449C44.6197 57.0449 57.0453 44.6193 57.0453 29.4324C57.0453 14.2456 44.6197 1.81995 29.4328 1.81995C14.2459 1.81995 1.82031 14.2456 1.82031 29.4324C1.82031 44.6193 14.2459 57.0449 29.4328 57.0449Z" fill="none" stroke={stroke} strokeWidth="3.64" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M21.6182 37.2465L37.2467 21.6179" stroke={stroke} strokeWidth="3.64" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M37.2467 37.2465L21.6182 21.6179" stroke={stroke} strokeWidth="3.64" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
};
